.row {
  margin: 0 -8px;
  padding: 1px 8px;
  border-radius: var(--mantine-radius-sm);
}

.row:hover {
  background-color: var(--mantine-color-gray-1);
}

[data-mantine-color-scheme="dark"] .row:hover {
  background-color: var(--mantine-color-dark-6);
}

.icon {
  flex-shrink: 0;
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

[data-mantine-color-scheme="dark"] .body {
  border-bottom-color: var(--mantine-color-dark-5);
}

.row:last-of-type .body {
  border-bottom-color: transparent;
}

.note {
  align-items: flex-start;
  border-bottom: none;
}
